import React from "react";
import { useTranslation } from "react-i18next";
import "./NavBar.css";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (language) => {
    i18n.changeLanguage(language);
  };

  return (
    <div className="language-switcher">
      <div className="language-toggle" role="group" aria-label="Language switcher">
        <button
          type="button"
          className={`language-option${i18n.language === "en" ? " is-active" : ""}`}
          onClick={() => handleLanguageChange("en")}
          aria-pressed={i18n.language === "en"}
        >
          <span aria-hidden="true">🇬🇧</span>
          <span className="language-label">EN</span>
        </button>
        <button
          type="button"
          className={`language-option${i18n.language === "pl" ? " is-active" : ""}`}
          onClick={() => handleLanguageChange("pl")}
          aria-pressed={i18n.language === "pl"}
        >
          <span aria-hidden="true">🇵🇱</span>
          <span className="language-label">PL</span>
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
